import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { YearAndMonth } from "../../services/activity.service";

@Component({
    selector: "datepicker-year-month",
    template: require('./datepicker-year-month.component.html')
})
export class DatepickerYearMonthComponent implements OnInit {

    @Input()
    years: number[] = [];

    @Input()
    year: number;

    @Input()
    month: number;

    @Input()
    fxLayout: string;

    @Output()
    onChange = new EventEmitter<YearAndMonth>();

    months: Month[];

    ngOnInit(): void {
        this.months = this.getMonths();
        this.fxLayout = this.fxLayout ?? "column";

        const d = new Date();
        this.year = this.year ?? d.getFullYear();
        this.month = this.month ?? d.getMonth();

        this.onChange.emit({ Year: this.year, Month: this.month });
    }

    onYearChange(year: number): void {
        this.onChange.emit({ Year: year, Month: this.month });
    }

    onMonthChange(month: number): void {
        this.onChange.emit({ Year: this.year, Month: month });
    }

    private getMonths(): Month[] {
        return [
            { id: 0, name: "January" },
            { id: 1, name: "February" },
            { id: 2, name: "March" },
            { id: 3, name: "April" },
            { id: 4, name: "May" },
            { id: 5, name: "June" },
            { id: 6, name: "July" },
            { id: 7, name: "August" },
            { id: 8, name: "September" },
            { id: 9, name: "October" },
            { id: 10, name: "November" },
            { id: 11, name: "December" },
        ];
    }
}

export interface Month {
    id: number;
    name: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/shared/datepicker-year-month.component.ts